import { BYOStepId } from 'api/contentful/contentTypes.cloverdotcom';
import { BYOSelectionState } from './useBYOSelections';

export const useSelectedItems = (selectionState: BYOSelectionState) => {
  const selectedPlan = Object.values(selectionState[BYOStepId.POS_NEEDS])[0];
  const selectedDevices = Object.values(selectionState[BYOStepId.DEVICES]);
  const selectedAccessories = Object.values(selectionState[BYOStepId.ACCESSORIES]);
  const selectedDevicesAndAccessories = [...selectedDevices, ...selectedAccessories];

  return selectedPlan ? [selectedPlan, ...selectedDevicesAndAccessories] : selectedDevicesAndAccessories;
};
